import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@babackapp/ui/components/dialog";
import { useCallback } from "react";
import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import { WorkflowDto } from "@babackapp/private-api-client/types";

export const RemoveWorkflowDialog = ({
  isOpen,
  onClose,
  onSubmit,
  selectedWorkflow,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (workflowID: string) => void;
  selectedWorkflow: WorkflowDto;
}) => {
  const t = useTranslation();

  const _handleSubmit = useCallback(() => {
    if (!selectedWorkflow) return;
    onClose();
    return onSubmit(selectedWorkflow.id);
  }, [onSubmit, selectedWorkflow]);

  return (
    <>
      {selectedWorkflow && (
        <Dialog open={isOpen} onOpenChange={onClose}>
          <DialogContent className="pt-10">
            <DialogHeader className="justify-center">
              <DialogTitle className="text-center">
                {`${t("misc.delete")} ${selectedWorkflow.name}`}
              </DialogTitle>
              <DialogDescription className="text-center">
                {t("workflow.comment.supprDesc")}
              </DialogDescription>
            </DialogHeader>
            <div className="flex justify-center gap-4">
              <Button className="w-1/2" onClick={onClose} variant={"outline"}>
                {t("misc.cancel")}
              </Button>
              <Button
                variant={"default"}
                onClick={_handleSubmit}
                type="button"
                className="w-1/2"
              >
                {t("misc.delete")}
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
